import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { namespacedClassnames, calculateTextAreaSelection } from '../../../../common';
import { Tooltip } from '../../../../primitives/tooltip/tooltip';
import TextAreaDefault from 'react-textarea-autosize';
// tslint:disable-next-line:no-duplicate-imports
import * as TextAreaAll from 'react-textarea-autosize';
/*
    very hacky, but turns out that there is a different between tests running
    and local environment / widget when it comes to the default exports.
    probably webpack (yoshi or sandbox) do something that our tests / browserify doesn't.
    this wasted enough time for now so the hack below is the best solution but if you see it
    later than April 2019 please try solve it again. 🙏🏻
 */
var TextAreaComp = typeof TextAreaAll === 'object' ? TextAreaDefault : TextAreaAll;
export var textAreaKey = 'text-area';
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var props = _this.props;
            if (!props.disabled) {
                props.onChange(e.target.value, e);
            }
        };
        _this.onSelect = function (e) {
            if (_this.props.onSelect) {
                var t = e.target;
                var selection = calculateTextAreaSelection(t, _this.props.value);
                _this.props.onSelect(selection);
            }
        };
        return _this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, autoSize = _a.autoSize, props = __rest(_a, ["disabled", "autoSize"]);
        var cn = namespacedClassnames(textAreaKey, props.className, { disabled: !!disabled, autosize: autoSize });
        var maybeOnSelect = !autoSize ? this.onSelect : undefined;
        var textAreaProps = __assign(__assign({}, props), { className: cn, onChange: this.onChange, disabled: !!disabled, onSelect: maybeOnSelect });
        var Comp = autoSize ? TextAreaComp : 'textarea';
        var body = React.createElement(Comp, __assign({}, textAreaProps));
        return !!disabled ? (React.createElement(Tooltip, { body: disabled, relativeToBody: true }, body)) : body;
    };
    return TextArea;
}(React.PureComponent));
export { TextArea };
//# sourceMappingURL=index.js.map